module.exports = __webpack_public_path__ + "static/media/signage-indoor-img3.4b50ec08.jpg";